import React, { memo } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { CardView, rem, Spacer } from 'design-system';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import { Tier } from 'features/premium/entities';
import useOnboarding from '../hooks/useOnboarding';
const graphicsImg = require('../img/potsProductTourGraphics.png');
const ProductTourIntroCard = ({ cardStyles, containerStyle }) => {
    const highestInterestRate = useAppSelector((state) => state.pots.interestPotsTierRateMap?.[Tier.ultimate]);
    const [onboard] = useOnboarding();
    return (<View style={containerStyle}>
      <View style={styles.topContainer}>
        <Text Text-24 centered>
          Grow your savings
        </Text>
        <Spacer h={8}/>
        <Text TextThin-16 Secondary centered>
          {'A better relationship with money\nstarts here'}
        </Text>
      </View>

      <CardView withPadding noMarginBottom noMarginTop style={cardStyles}>
        <View style={styles.imgContainer}>
          <Image source={graphicsImg} style={styles.img} resizeMode="cover"/>
        </View>
        {!highestInterestRate ? (<Text Text-16>Earn interest on your{'\n'}savings, FSCS protected</Text>) : (<Text Text-16>
            Earn up to{' '}
            <Text Numbers-16 Primary>
              {highestInterestRate}%
            </Text>{' '}
            AER on your{'\n'}savings, FSCS protected
          </Text>)}
        <Spacer h={4}/>
        <Text TextThin-14 Secondary>
          {'Open a pot and start earning\ninterest!'}
        </Text>
        <Spacer h={12}/>
        <View style={styles.row}>
          <Button square brandReversed hug title="Create a Pot" onPress={onboard}/>
        </View>
      </CardView>
    </View>);
};
export default memo(ProductTourIntroCard);
const styles = StyleSheet.create({
    topContainer: {
        paddingTop: rem(24),
        paddingBottom: rem(40),
        paddingHorizontal: rem(24),
    },
    row: {
        flexDirection: 'row',
    },
    imgContainer: {
        right: 0,
        bottom: 0,
        width: rem(170),
        height: rem(170),
        position: 'absolute',
    },
    img: {
        width: '100%',
        height: '100%',
    },
});
